'use client'

import { IconArrowLeft, IconSearch } from '@macarongfactory/web-icons'
import { Text } from '@macarongfactory/web-ui'
import { useRouter } from 'next/navigation'

export const IN_APP_TOP_BAR_HEIGHT_PX = 56
const ICON_SIZE_PX = 24
const ICON_BUTTON_SIZE_PX = 44

interface IInAppTopBarProps {
  title: string
}

const InAppTopBar = ({ title }: IInAppTopBarProps) => {
  const router = useRouter()

  const handleBack = () => {
    router.back()
  }

  const handleSearch = () => {
    router.push('/modoocar/search')
  }

  return (
    <header
      className='sticky top-0 z-20 flex items-center bg-background-surface-default px-dimension-x1 py-[6px]'
      style={{ height: IN_APP_TOP_BAR_HEIGHT_PX }}
    >
      <div className='flex min-w-0 flex-1 items-center'>
        <button
          type='button'
          aria-label='이전 화면으로 이동'
          onClick={handleBack}
          className='flex shrink-0 items-center justify-center'
          style={{ width: ICON_BUTTON_SIZE_PX, height: ICON_BUTTON_SIZE_PX }}
        >
          <IconArrowLeft
            width={ICON_SIZE_PX}
            height={ICON_SIZE_PX}
            className='text-foreground-neutral-strong'
          />
        </button>
        <Text
          as='h1'
          variant='title-1-semibold'
          color='text-foreground-neutral-strong'
          className='min-w-0 truncate'
        >
          {title}
        </Text>
      </div>

      <button
        type='button'
        aria-label='모두의 차고 검색'
        onClick={handleSearch}
        className='flex shrink-0 items-center justify-center'
        style={{ width: ICON_BUTTON_SIZE_PX, height: ICON_BUTTON_SIZE_PX }}
      >
        <IconSearch
          width={ICON_SIZE_PX}
          height={ICON_SIZE_PX}
          className='text-foreground-neutral-strong'
        />
      </button>
    </header>
  )
}

export default InAppTopBar
